import React, { PureComponent, Fragment } from 'react';
import classNames from 'classnames';

import { BackgroundLayer, Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import withDeviceType from '../../hoc/withDeviceType';
import TextPlugin from '../cms/TextPlugin';

import './Hero.module.css';

const HeroSection = DisplayComponent(
  class HeroSection extends PureComponent {
    render() {
      const {
        classes,
        themeColor,
        highlightImage,
        backgroundImage,
        backgroundHeight,
        backgroundWidth,
        backgroundColor,
        darkOverlay,
        overlapMenu,
        overlapSubNav,
        copyPosition,
        copyBackgroundColor,
        copyWidth,
        children,
        headerMenuBg,
        body,
        mobileImage,
        mobileImageHeight,
        mobileImageWidth,
        heightRestrict,
        copyPrimaryAlignmentSmall,
        copySecondaryAlignmentSmall,
        copyBackgroundColorSmall,
        copySmallOrder,
        backgroundImageSmallOrder,
        isMobile,
        isTablet,
        popOutImage,
        mobiletextoverlay
      } = this.props;

      const bgImageRatio = (backgroundHeight / backgroundWidth) * 100;

      const organize = {};
      let offset = 0;

      const styling = {
        [`${copyPrimaryAlignmentSmall}`]: copyPrimaryAlignmentSmall,
        [`${copySecondaryAlignmentSmall}`]: copySecondaryAlignmentSmall,
        [`${copyBackgroundColorSmall}`]: copyBackgroundColorSmall
      };

      let mobileImageRatio = bgImageRatio;
      if (mobileImage) {
        mobileImageRatio = (mobileImageWidth / mobileImageHeight) * 100;
      }

      offset = 1;
      if (!highlightImage) {
        switch (copyPosition) {
          case 'left':
            offset = 1;
            break;
          case 'center':
            offset = undefined;
            break;
          case 'right':
            offset = 24 - copyWidth;
            break;
          default:
        }
      } else {
        switch (copyPosition) {
          case 'left':
            organize.order = 0;
            break;
          case 'right':
            organize.order = 2;
            break;
          default:
        }
      }
      let gridAlignment;
      if (copyPosition === 'center') {
        gridAlignment = 'align-center';
      }
      return (
        <div
          styleName={classNames(
            overlapSubNav ? 'overlap-sub-nav' : '',
            overlapMenu ? 'overlap' : '',
            'hero-position'
          )}
        >
          {isMobile && mobileImage ? (
            <div className={classes} styleName="mobile-flex">
              <div
                styleName={`small-background-order-${
                  backgroundImageSmallOrder ? backgroundImageSmallOrder : 1
                }`}
              >
                <BackgroundLayer
                  imageUrl={mobileImage ? mobileImage : backgroundImage}
                  imageSize={100}
                  darkOverlay={darkOverlay}
                  bgHeight={mobileImageRatio}
                  backgroundColor={backgroundColor || copyBackgroundColor}
                />
              </div>
              <div
                styleName={classNames(
                  styling,
                  `small-copy-order-${copySmallOrder ? copySmallOrder : 2}`,
                  copySmallOrder === 2
                    ? 'mobile-text-bottom'
                    : 'mobile-text-top',
                  { 'mobile-text-overlay': mobiletextoverlay }
                )}
                style={{
                  color: mobiletextoverlay ? themeColor : null,
                  marginTop: mobiletextoverlay && overlapMenu ? 80 : null
                }}
              >
                <Grid
                  hasContainer={true}
                  direction="x"
                  primaryAlignment={gridAlignment}
                >
                  <Cell
                    mediumSize={copyWidth - 1}
                    styles={organize}
                    mediumOffset={offset}
                  >
                    <div>
                      {body ? (
                        <TextPlugin body={body}>{children}</TextPlugin>
                      ) : (
                        children
                      )}
                    </div>
                  </Cell>
                  {highlightImage && (
                    <Cell
                      largeSize={24 - copyWidth}
                      styles={{ order: 1, position: 'relative' }}
                    >
                      <div styleName={`${popOutImage ? 'popout' : ''}`}>
                        <Picture largeImage={highlightImage} width="100%" />
                      </div>
                    </Cell>
                  )}
                </Grid>
              </div>
            </div>
          ) : isTablet ? (
            <Fragment>
              {headerMenuBg && <div styleName={`header-menu-bg `} />}
              <div
                className={classes}
                styleName={classNames('panel', {
                  'height-restricted': heightRestrict
                })}
                style={{
                  backgroundImage: `url(${backgroundImage})`,
                  minHeight: heightRestrict ? 'auto' : `${bgImageRatio}vw`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                {darkOverlay && <div styleName="overlay" />}
                <div styleName="grid-reset">
                  <Grid direction="x" primaryAlignment={gridAlignment}>
                    <Cell
                      mediumSize={copyWidth - 1}
                      styles={organize}
                      mediumOffset={offset}
                    >
                      <div styleName={`content `} style={{ color: themeColor }}>
                        {body ? (
                          <TextPlugin body={body}>{children}</TextPlugin>
                        ) : (
                          children
                        )}
                      </div>
                    </Cell>
                    {highlightImage && (
                      <Cell
                        largeSize={24 - copyWidth}
                        styles={{ order: 1, position: 'relative' }}
                      >
                        <div styleName={`${popOutImage ? 'popout' : ''}`}>
                          <Picture largeImage={highlightImage} width="100%" />
                        </div>
                      </Cell>
                    )}
                  </Grid>
                </div>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              {headerMenuBg && <div styleName={`header-menu-bg `} />}
              <div
                className={classes}
                styleName={classNames('panel', {
                  'height-restricted': heightRestrict
                })}
                style={{
                  backgroundImage: `url(${backgroundImage})`,
                  minHeight: `${bgImageRatio}vw`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                {darkOverlay && <div styleName="overlay" />}
                <div styleName="grid-reset">
                  <Grid direction="x" primaryAlignment={gridAlignment}>
                    <Cell
                      mediumSize={copyWidth - 1}
                      styles={organize}
                      mediumOffset={offset}
                    >
                      <div styleName={`content `} style={{ color: themeColor }}>
                        {body ? (
                          <TextPlugin body={body}>{children}</TextPlugin>
                        ) : (
                          children
                        )}
                      </div>
                    </Cell>
                    {highlightImage && (
                      <Cell
                        largeSize={24 - copyWidth}
                        styles={{ order: 1, position: 'relative' }}
                      >
                        <div styleName={`${popOutImage ? 'popout' : ''}`}>
                          <Picture largeImage={highlightImage} width="100%" />
                        </div>
                      </Cell>
                    )}
                  </Grid>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      );
    }
  }
);

HeroSection.propTypes = {};

export default withDeviceType(HeroSection);
